import { Guid } from "guid-typescript";
import { IMessage } from "../../../IMessage";

//Generated code, do not modify

export class CreateTimelineMonthCoverCommand implements IMessage {
    timelineMonthId!: Guid;
    mimeType!: string;
    content!: string;

    public constructor(init?: Partial<CreateTimelineMonthCoverCommand>) {
        Object.assign(this, init);
    }

    getMethod = () => "POST";

    getUrl = () => `/admin/timeline-months/${this.timelineMonthId.toString()}/cover`;

    getQueryString = () => undefined;

    getBody = () => {
        return {
            mimeType: this.mimeType,
            content: this.content,
        };
    }
}